import React from "react";
import cx from "classnames";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import styles from "./Tab.module.styl";

export default function Tab({ children, isActive, onClick, to, style, dataTestName }) {
    if (to) {
        return (
            <NavLink
                className={styles.item}
                activeClassName={styles.active}
                to={to}
                onClick={onClick}
                data-test-name={dataTestName}
            >
                {children}
            </NavLink>
        );
    }

    const classes = cx(styles.item, isActive && styles.active, style);

    return (
        <button className={classes} onClick={onClick} data-test-name={dataTestName}>
            {children}
        </button>
    );
}

Tab.propTypes = {
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
    to: PropTypes.string,
    style: PropTypes.string,
    dataTestName: PropTypes.string,
};

Tab.defaultProps = {
    isActive: false,
};
